import * as React from "react";
import Box from "@mui/material/Box";
const HomeHeader = () => {
  return (
    <img src="/logos/Icon_frame_wareozo_White_copy_650x200.svg" alt='Wareozo' width='325px' height='100px' className='logo-box' style={{marginTop: "-50px"}}/>
  );
};

export default HomeHeader;
